import { dayjsTz, dayjsUtcToTz } from "@/app/_utils/dayjs";
import { isNewSignupEvent } from "@/app/_utils/guestSignups";
import dayjs from "dayjs";
import { forEach, map } from "lodash";

export const groupByIntakeMethod = (list: Array<any>, param: string) => {
  if (!list) return [];
  const dict: { [key: string]: number } = {};
  const final_list: any = [];
  for (let i = 0; i < list.length; i++) {
    let key = list[i][param];

    // consolidate misc intakes
    let misc = ["Tik Tok", "The Nudge", "Time Out NY"];
    if (misc.includes(list[i][param])) key = "Other";
    dict[key] ? (dict[key] += 1) : (dict[key] = 1);
  }

  for (const [key, value] of Object.entries(dict)) {
    let dict = {
      name: key,
      value: value,
    };
    final_list.push(dict);
  }
  return final_list.sort();
};

export const groupByDay = (list: Array<any>, param: string, days: number) => {
  if (!list) return [];
  const dict: { [key: string]: any } = {};
  const final_list: any = [];

  for (let i = 0; i < days; i++) {
    dict[dayjsTz().subtract(i, "days").format("YYYY-MM-DD")] = [];
  }

  for (let i = 0; i < list.length; i++) {
    let date = dayjsUtcToTz(list[i][param]).format("YYYY-MM-DD");
    dict[date] ? dict[date].push(list[i]) : (dict[date] = [list[i]]);
  }

  for (const [key, value] of Object.entries(dict)) {
    let dict = {
      day: dayjsTz(key).format("ddd, MMM D"),
      data: value,
    };
    final_list.push(dict);
  }
  return final_list.reverse();
};

export const getCountByDay = (
  list: Array<any>,
  date_param: string,
  days: number
) => {
  if (!list) return [];
  const dict: { [key: string]: number } = {};
  const final_list: any = [];
  for (let i = 0; i < days; i++) {
    dict[dayjsTz().subtract(i, "days").format("YYYY-MM-DD")] = 0;
  }

  for (let i = 0; i < list.length; i++) {
    let date = dayjsUtcToTz(list[i][date_param]).format("YYYY-MM-DD");
    dict[date] ? (dict[date] += 1) : (dict[date] = 1);
  }

  for (const [key, value] of Object.entries(dict)) {
    let dict = {
      name: dayjsTz(key).format("ddd, MMM D"),
      count: value,
    };
    final_list.push(dict);
  }
  return final_list.reverse();
};

export const groupByDateSplit = (list: Array<any>, param: string) => {
  if (!list) return [];
  const dict: any = {};
  const final_list: any = [];
  // 1. create dict with this week as keys yyyy-mm-dd
  for (let i = 0; i < 8; i++) {
    dict[dayjsTz().subtract(i, "days").format("YYYY-MM-DD")] = {
      signups: 0,
      newSignups: 0,
    };
  }

  // 2. loop through list — New vs Repeat aligned with waitlist badge (see guestSignups.ts)
  for (let i = 0; i < list.length; i++) {
    const date = dayjsUtcToTz(list[i][param]).format("YYYY-MM-DD");
    const isNew = isNewSignupEvent(list[i].signups);

    if (dict[date]) {
      dict[date] = isNew
        ? { ...dict[date], newSignups: dict[date].newSignups + 1 }
        : { ...dict[date], signups: dict[date].signups + 1 };
    } else {
      dict[date] = isNew
        ? { signups: 0, newSignups: 1 }
        : { newSignups: 0, signups: 1 };
    }
  }

  forEach(dict, (value, key) => {
    let dict = {
      name: dayjsTz(key).format("ddd, MMM D"),
      signups: value.signups,
      newSignups: value.newSignups,
    };
    final_list.push(dict);
  });

  return final_list.reverse();
};

export const countByDate = (
  list: Array<any>,
  date_param: string,
  date: any
) => {
  if (!list) return 0;
  let signups = 0;
  for (let i = 0; i < list.length; i++) {
    if (dayjsUtcToTz(list[i][date_param]).isSame(date, "day")) {
      signups += 1;
    }
  }
  return signups;
};

export function groupByMonth(objects: any, param: string) {
  const counts: any = {};

  objects.forEach((obj: any) => {
    const date = dayjsUtcToTz(obj[param]);
    const monthYear = date.format("YYYY-M");

    // If the month-year combination doesn't exist in the counts object, initialize it
    if (!counts[monthYear]) {
      counts[monthYear] = 0;
    }

    // Increment the count for the specific month-year
    counts[monthYear]++;
  });

  const final_list: any = [];

  forEach(counts, (value, key) => {
    let dict = {
      name: dayjsTz(key).format("MMM YYYY"),
      signups: value,
    };
    final_list.push(dict);
  });

  return final_list.reverse();
}

export function groupByLocality(guest: any) {
  const count: any = {
    local: 0,
    nonLocal: 0,
  };

  const nycCodes = [
    "+1212",
    "+1332",
    "+1646",
    "+1917",
    "+1718",
    "+1347",
    "+1929",
  ];

  map(guest, (it) => {
    it.phone && nycCodes.includes(it.phone.slice(0, 5))
      ? (count.local += 1)
      : (count.nonLocal += 1);
  });

  const final_list: any = [];

  forEach(count, (value, key) => {
    let dict = {
      name: key,
      count: value,
    };
    final_list.push(dict);
  });

  return final_list;
}

export function groupByMonthTotal(guests: any) {
  const monthCounts: any = {};
  map(guests, (it) => {
    const date = dayjsUtcToTz(it.signup_date).startOf("month").unix();
    if (monthCounts[date]) {
      monthCounts[date] += 1;
    } else {
      monthCounts[date] = 1;
    }
  });

  const final_list: any = [];

  forEach(monthCounts, (value, key) => {
    let dict = {
      timestamp: key,
      count: value,
    };
    final_list.push(dict);
  });
  const newList = final_list.sort(
    (a: any, b: any) => a.timestamp - b.timestamp
  );

  let cumulativeTotal = 0;
  return map(newList, (it) => {
    cumulativeTotal += it.count;
    return {
      ...it,
      timestamp: dayjs.unix(it.timestamp).format("MMM YYYY"),
      count: cumulativeTotal,
    };
  });
}
